import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bulkClassDetails: {},
  ticketsList: [],
}

export const bulkClass = createSlice({
  name: "class",
  initialState,
  reducers: {
    setBulkClassDetails: (state, action) => {
      state.bulkClassDetails = action.payload;
      return state;
    },
    setTicketsList: (state, payload) => {
      state.ticketsList = payload.payload;
      return state;
    },
  },
});

export const {
  setBulkClassDetails,
  setTicketsList,
} = bulkClass.actions;

export default bulkClass.reducer;
